"use strict";

function _interopDefault(t) {
  return t && "object" == typeof t && "default" in t ? t.default : t;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = _interopDefault(require("react"));

require("prop-types");

var history = require("history");

require("tiny-warning");

var createContext = _interopDefault(require("mini-create-react-context")),
    invariant = _interopDefault(require("tiny-invariant")),
    pathToRegexp = _interopDefault(require("path-to-regexp"));

require("react-is");

var hoistStatics = _interopDefault(require("hoist-non-react-statics"));

function _extends() {
  return (_extends = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function _inheritsLoose(t, e) {
  t.prototype = Object.create(e.prototype), (t.prototype.constructor = t).__proto__ = e;
}

function _objectWithoutPropertiesLoose(t, e) {
  if (null == t) return {};
  var n,
      o,
      r = {},
      a = Object.keys(t);

  for (o = 0; o < a.length; o++) {
    n = a[o], 0 <= e.indexOf(n) || (r[n] = t[n]);
  }

  return r;
}

var createNamedContext = function createNamedContext(t) {
  var e = createContext();
  return e.displayName = t, e;
},
    context = createNamedContext("Router"),
    Router = function (n) {
  function t(t) {
    var e;
    return (e = n.call(this, t) || this).state = {
      location: t.history.location
    }, e._isMounted = !1, e._pendingLocation = null, t.staticContext || (e.unlisten = t.history.listen(function (t) {
      e._isMounted ? e.setState({
        location: t
      }) : e._pendingLocation = t;
    })), e;
  }

  _inheritsLoose(t, n), t.computeRootMatch = function (t) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: "/" === t
    };
  };
  var e = t.prototype;
  return e.componentDidMount = function () {
    this._isMounted = !0, this._pendingLocation && this.setState({
      location: this._pendingLocation
    });
  }, e.componentWillUnmount = function () {
    this.unlisten && this.unlisten();
  }, e.render = function () {
    return React.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: t.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  }, t;
}(React.Component),
    MemoryRouter = function (r) {
  function t() {
    for (var t, e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
      n[o] = arguments[o];
    }

    return (t = r.call.apply(r, [this].concat(n)) || this).history = history.createMemoryHistory(t.props), t;
  }

  return _inheritsLoose(t, r), t.prototype.render = function () {
    return React.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  }, t;
}(React.Component),
    Lifecycle = function (t) {
  function e() {
    return t.apply(this, arguments) || this;
  }

  _inheritsLoose(e, t);

  var n = e.prototype;
  return n.componentDidMount = function () {
    this.props.onMount && this.props.onMount.call(this, this);
  }, n.componentDidUpdate = function (t) {
    this.props.onUpdate && this.props.onUpdate.call(this, this, t);
  }, n.componentWillUnmount = function () {
    this.props.onUnmount && this.props.onUnmount.call(this, this);
  }, n.render = function () {
    return null;
  }, e;
}(React.Component);

function Prompt(t) {
  var o = t.message,
      e = t.when,
      r = void 0 === e || e;
  return React.createElement(context.Consumer, null, function (t) {
    if (t || invariant(!1), !r || t.staticContext) return null;
    var n = t.history.block;
    return React.createElement(Lifecycle, {
      onMount: function onMount(t) {
        t.release = n(o);
      },
      onUpdate: function onUpdate(t, e) {
        e.message !== o && (t.release(), t.release = n(o));
      },
      onUnmount: function onUnmount(t) {
        t.release();
      },
      message: o
    });
  });
}

var cache = {},
    cacheLimit = 1e4,
    cacheCount = 0;

function compilePath(t) {
  if (cache[t]) return cache[t];
  var e = pathToRegexp.compile(t);
  return cacheCount < cacheLimit && (cache[t] = e, cacheCount++), e;
}

function generatePath(t, e) {
  return void 0 === t && (t = "/"), void 0 === e && (e = {}), "/" === t ? t : compilePath(t)(e, {
    pretty: !0
  });
}

function Redirect(t) {
  var a = t.computedMatch,
      i = t.to,
      e = t.push,
      c = void 0 !== e && e;
  return React.createElement(context.Consumer, null, function (t) {
    t || invariant(!1);
    var e = t.history,
        n = t.staticContext,
        o = c ? e.push : e.replace,
        r = history.createLocation(a ? "string" == typeof i ? generatePath(i, a.params) : _extends({}, i, {
      pathname: generatePath(i.pathname, a.params)
    }) : i);
    return n ? (o(r), null) : React.createElement(Lifecycle, {
      onMount: function onMount() {
        o(r);
      },
      onUpdate: function onUpdate(t, e) {
        var n = history.createLocation(e.to);
        history.locationsAreEqual(n, _extends({}, r, {
          key: n.key
        })) || o(r);
      },
      to: i
    });
  });
}

var cache$1 = {},
    cacheLimit$1 = 1e4,
    cacheCount$1 = 0;

function compilePath$1(t, e) {
  var n = "" + e.end + e.strict + e.sensitive,
      o = cache$1[n] || (cache$1[n] = {});
  if (o[t]) return o[t];
  var r = [],
      a = {
    regexp: pathToRegexp(t, r, e),
    keys: r
  };
  return cacheCount$1 < cacheLimit$1 && (o[t] = a, cacheCount$1++), a;
}

function matchPath(u, t) {
  void 0 === t && (t = {}), "string" != typeof t && !Array.isArray(t) || (t = {
    path: t
  });
  var e = t,
      n = e.path,
      o = e.exact,
      p = void 0 !== o && o,
      r = e.strict,
      h = void 0 !== r && r,
      a = e.sensitive,
      l = void 0 !== a && a;
  return [].concat(n).reduce(function (t, e) {
    if (!e && "" !== e) return null;
    if (t) return t;
    var n = compilePath$1(e, {
      end: p,
      strict: h,
      sensitive: l
    }),
        o = n.regexp,
        r = n.keys,
        a = o.exec(u);
    if (!a) return null;
    var i = a[0],
        c = a.slice(1),
        s = u === i;
    return p && !s ? null : {
      path: e,
      url: "/" === e && "" === i ? "/" : i,
      isExact: s,
      params: r.reduce(function (t, e, n) {
        return t[e.name] = c[n], t;
      }, {})
    };
  }, null);
}

var Route = function (t) {
  function e() {
    return t.apply(this, arguments) || this;
  }

  return _inheritsLoose(e, t), e.prototype.render = function () {
    var c = this;
    return React.createElement(context.Consumer, null, function (t) {
      t || invariant(!1);

      var e = c.props.location || t.location,
          n = _extends({}, t, {
        location: e,
        match: c.props.computedMatch ? c.props.computedMatch : c.props.path ? matchPath(e.pathname, c.props) : t.match
      }),
          o = c.props,
          r = o.children,
          a = o.component,
          i = o.render;

      return Array.isArray(r) && 0 === r.length && (r = null), React.createElement(context.Provider, {
        value: n
      }, n.match ? r ? "function" == typeof r ? r(n) : r : a ? React.createElement(a, n) : i ? i(n) : null : "function" == typeof r ? r(n) : null);
    });
  }, e;
}(React.Component);

function addLeadingSlash(t) {
  return "/" === t.charAt(0) ? t : "/" + t;
}

function addBasename(t, e) {
  return t ? _extends({}, e, {
    pathname: addLeadingSlash(t) + e.pathname
  }) : e;
}

function stripBasename(t, e) {
  if (!t) return e;
  var n = addLeadingSlash(t);
  return 0 !== e.pathname.indexOf(n) ? e : _extends({}, e, {
    pathname: e.pathname.substr(n.length)
  });
}

function createURL(t) {
  return "string" == typeof t ? t : history.createPath(t);
}

function staticHandler(t) {
  return function () {
    invariant(!1);
  };
}

function noop() {}

var StaticRouter = function (r) {
  function t() {
    for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
      n[o] = arguments[o];
    }

    return (e = r.call.apply(r, [this].concat(n)) || this).handlePush = function (t) {
      return e.navigateTo(t, "PUSH");
    }, e.handleReplace = function (t) {
      return e.navigateTo(t, "REPLACE");
    }, e.handleListen = function () {
      return noop;
    }, e.handleBlock = function () {
      return noop;
    }, e;
  }

  _inheritsLoose(t, r);

  var e = t.prototype;
  return e.navigateTo = function (t, e) {
    var n = this.props,
        o = n.basename,
        r = void 0 === o ? "" : o,
        a = n.context,
        i = void 0 === a ? {} : a;
    i.action = e, i.location = addBasename(r, history.createLocation(t)), i.url = createURL(i.location);
  }, e.render = function () {
    var t = this.props,
        e = t.basename,
        n = void 0 === e ? "" : e,
        o = t.context,
        r = void 0 === o ? {} : o,
        a = t.location,
        i = void 0 === a ? "/" : a,
        c = _objectWithoutPropertiesLoose(t, ["basename", "context", "location"]),
        s = {
      createHref: function createHref(t) {
        return addLeadingSlash(n + createURL(t));
      },
      action: "POP",
      location: stripBasename(n, history.createLocation(i)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler(),
      goBack: staticHandler(),
      goForward: staticHandler(),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return React.createElement(Router, _extends({}, c, {
      history: s,
      staticContext: r
    }));
  }, t;
}(React.Component),
    Switch = function (t) {
  function e() {
    return t.apply(this, arguments) || this;
  }

  return _inheritsLoose(e, t), e.prototype.render = function () {
    var t = this;
    return React.createElement(context.Consumer, null, function (n) {
      n || invariant(!1);
      var o,
          r,
          a = t.props.location || n.location;
      return React.Children.forEach(t.props.children, function (t) {
        if (null == r && React.isValidElement(t)) {
          var e = (o = t).props.path || t.props.from;
          r = e ? matchPath(a.pathname, _extends({}, t.props, {
            path: e
          })) : n.match;
        }
      }), r ? React.cloneElement(o, {
        location: a,
        computedMatch: r
      }) : null;
    });
  }, e;
}(React.Component);

function withRouter(o) {
  function t(t) {
    var e = t.wrappedComponentRef,
        n = _objectWithoutPropertiesLoose(t, ["wrappedComponentRef"]);

    return React.createElement(context.Consumer, null, function (t) {
      return t || invariant(!1), React.createElement(o, _extends({}, n, t, {
        ref: e
      }));
    });
  }

  var e = "withRouter(" + (o.displayName || o.name) + ")";
  return t.displayName = e, t.WrappedComponent = o, hoistStatics(t, o);
}

var useContext = React.useContext;

function useHistory() {
  return useContext(context).history;
}

function useLocation() {
  return useContext(context).location;
}

function useParams() {
  var t = useContext(context).match;
  return t ? t.params : {};
}

function useRouteMatch(t) {
  return t ? matchPath(useLocation().pathname, t) : useContext(context).match;
}

exports.MemoryRouter = MemoryRouter, exports.Prompt = Prompt, exports.Redirect = Redirect, exports.Route = Route, exports.Router = Router, exports.StaticRouter = StaticRouter, exports.Switch = Switch, exports.__RouterContext = context, exports.generatePath = generatePath, exports.matchPath = matchPath, exports.useHistory = useHistory, exports.useLocation = useLocation, exports.useParams = useParams, exports.useRouteMatch = useRouteMatch, exports.withRouter = withRouter;